/**
 * Inicialización de la clase ExternalResponse, modelo para la repsuesta externa
 *
 * *Set ExternalResponse class, external response model*
 *
 * @access public
 * @type {class}
 */
export class ExternalResponse {
  /**
   * Origen de la respuesta externa
   *
   * *External response origin*
   *
   *  @type {string} origin
   */
  origin: string;

  /**
   * Función a ejecutar en nativo para ExternalResponse
   *
   * *Función to run in native environment to ExternalResponse*
   *
   *  @type {string} id
   */
  op: string;

  /**
   * Validación de modo de sincronización de la respuesta externa
   *
   * *External response sync mode validation*
   *
   *  @type {boolean} syncMode
   */
  syncMode: boolean;

  /**
   * Código de la respuesta externa
   *
   * *External response code*
   *
   *  @type {string} code
   */
  code: string;

  /**
   * Mesaje de la respuesta externa
   *
   * *External response message*
   *
   *  @type {string} message
   */
  message: string;

  /**
   * Información de la respuesta externa
   *
   * *External response data*
   *
   *  @type {any} data
   */
  data: any;
}
